import Button from "components/Blocks/Forms/Button/Button";

export default Button;
